import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from 'src/app/common/store/generic.selectors';
import { ITitleState } from './title.reducer';
import { Title, titleFeatureKey } from './types';

const titleFeatureState = createFeatureSelector<ITitleState>(titleFeatureKey);

export const titleSelectors = {
  getById: createApiCallSelectors<number, ITitleState>(
    titleFeatureState,
    'getById',
  ),
  postTitle: createApiCallSelectors<Title, ITitleState>(
    titleFeatureState,
    'postTitle',
  ),
  updateTitle: createApiCallSelectors<Title, ITitleState>(
    titleFeatureState,
    'updateTitle',
  ),
};
